import Page from './Page';
import Component from 'vue-class-component';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';

import template from './House.vue.html';
@Component({ template, components: { TabBar, HeaderComponent } })
export default class House extends Page {
    showNotice = false;

    created() {
        const id = this.app.reserve!.id;
        this.showNotice = !localStorage?.getItem('Mypage:ShownNotice:' + id);
    }

    samePeriodAllRoom() {
        return this.app.reserves_rooms.every(
            (rr) =>
                rr.start_time == this.app.reserve?.checkin &&
                rr.end_time == this.app.reserve?.checkout
        );
    }
}
